import { AxiosResponse } from "axios";
import { apiGet, getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import configStore from "../networkConfigStore";
import { networkConnectionsSliceActions } from "../networkConnectionsSlice";
import { PackageStatus, PackageStatusResponse } from "../packageStatus";
import { CHECK_DHCP_PACKAGE_STATUS } from "./networkConfigAPIPath";

const checkResponseIsValid = (response: AxiosResponse): boolean => {
    if (response.status >= 400) {
        console.debug(`dhcp package status error: ${response.status}`);
        return false;
    }
    if (!response.data) {
        console.debug("dhcp package status empty response");
        return false;
    }
    return true;
};

export const requestCheckDhcpPackageStatus = () => {
    const url = getGlobalStates().host + CHECK_DHCP_PACKAGE_STATUS;
    const token = getGlobalStates().keycloak?.token;

    const headers = token ? { headers: { Authorization: `Bearer ${token}` } } : undefined;

    return apiGet(url, headers)
        .then((response) => {
            if (!checkResponseIsValid(response)) {
                configStore.dispatch(networkConnectionsSliceActions.setDhcpPackageStatus(PackageStatus.ERROR));
                return;
            }
            const data = (response.data?.arg || response.data) as PackageStatusResponse;
            const status = data?.status;
            if (
                status === PackageStatus.INSTALLED ||
                status === PackageStatus.NOT_INSTALLED ||
                status === PackageStatus.ERROR
            ) {
                configStore.dispatch(networkConnectionsSliceActions.setDhcpPackageStatus(status));
            } else {
                configStore.dispatch(networkConnectionsSliceActions.setDhcpPackageStatus(PackageStatus.ERROR));
            }
        })
        .catch((err) => {
            console.warn("failed to fetch DHCP package status", err);
            configStore.dispatch(networkConnectionsSliceActions.setDhcpPackageStatus(PackageStatus.ERROR));
        });
};
